import * as React from "react"

function EditPencilIcon(props)
{
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m12 5 3 3m1.385-1.415a2.1 2.1 0 0 0-2.97-2.97L3 14v3h3L16.385 6.585Z" />
            <path stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="M3 21h9m3 0h2m3 0h1" />
        </svg>
    );
}

export default EditPencilIcon;